import * as React from "react";
import { Link } from "react-router";
import { BadgeAlert } from "lucide-react";
import { Button, useAuth } from "@ozpanel/ui";
import { useLicence } from "../screens/LicenceScreen";

// The licence's one line across the console (O7) — only when the verdict carries one (internal/licence
// .Decide: a trial ending, a lapsed licence, a licence not confirmed for a week, no key). Informational:
// nothing stops. Dismissed for the browser session, like the push banner beside it.
export function LicenceBanner() {
  const { who } = useAuth();
  const superAdmin = who?.role === "super_admin";
  const q = useLicence();
  const [dismissed, setDismissed] = React.useState(() => {
    try {
      return sessionStorage.getItem("ozp-licence-banner-dismissed") === "1";
    } catch {
      return false;
    }
  });
  const banner = q.data?.verdict.banner;
  if (!superAdmin || dismissed || !banner) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 border-b border-[var(--ozp-warn-line,#b45309)] bg-[var(--ozp-warn-soft,#451a03)] px-4 py-2 text-[12.5px] text-fg">
      <BadgeAlert size={15} className="shrink-0 text-warn" />
      <span className="min-w-0 flex-1">
        {banner}{" "}
        <Link to="/modules/licence" className="underline">
          Licence
        </Link>
      </span>
      <Button
        size="sm"
        variant="ghost"
        onClick={() => {
          setDismissed(true);
          try {
            sessionStorage.setItem("ozp-licence-banner-dismissed", "1");
          } catch {
            /* comes back next session: the safe failure */
          }
        }}
      >
        Not now
      </Button>
    </div>
  );
}
